import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useZoomFactor } from '~/hooks';
import { useLayoutSelector } from '../../redux';
import { StyledArrow } from './DragArrow.styled';

interface ArrowState {
	x: number;
	y: number;
	angle: number;
}

const DragArrow = () => {
	const draggedItem = useLayoutSelector(
		(state) => state.tuningShop.draggedItem,
	);
	const zoomFactor = useZoomFactor();
	const [arrow, setArrow] = useState<ArrowState | null>(null);

	useEffect(() => {
		if (!draggedItem) {
			setArrow(null);
			return;
		}

		const handleDragOver = (e: DragEvent) => {
			const cellEl = document.querySelector(
				`[data-tuning-category="${draggedItem.category}"]`,
			);
			if (!cellEl) return;

			const rect = cellEl.getBoundingClientRect();
			const targetX = rect.left + rect.width / 2;
			const targetY = rect.top + rect.height / 2;

			const angleRad = Math.atan2(targetY - e.clientY, targetX - e.clientX);
			const angleDeg = (angleRad * 180) / Math.PI;

			const offsetDist = 55;
			const arrowViewportX = e.clientX + Math.cos(angleRad) * offsetDist;
			const arrowViewportY = e.clientY + Math.sin(angleRad) * offsetDist;

			setArrow({
				x: arrowViewportX * (1 / zoomFactor),
				y: arrowViewportY * (1 / zoomFactor),
				angle: angleDeg,
			});
		};

		document.addEventListener('dragover', handleDragOver);
		return () => document.removeEventListener('dragover', handleDragOver);
	}, [draggedItem, zoomFactor]);

	if (!arrow) return null;

	return createPortal(
		<StyledArrow
			style={{
				left: arrow.x,
				top: arrow.y,
				transform: `translate(-50%, -50%) rotate(${arrow.angle}deg)`,
			}}
		>
			<svg
				width="9"
				height="16"
				viewBox="0 0 9 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.757814 0.652344L6.75781 7.65234L0.757814 14.6523"
					stroke="white"
					strokeWidth="2"
				/>
			</svg>
		</StyledArrow>,
		document.body,
	);
};

export { DragArrow };
